/**
 * Maps an app UI language (as reported by i18next, e.g. 'en', 'de-DE') to the `lang` value
 * accepted by Cognito Managed Login, forwarded as a query param from the BFF's `/auth/v1/login`
 * to the Cognito authorize URL.
 *
 * Managed Login's supported locale is `pt-BR`, not the bare `pt` that referee-app's i18n config
 * uses — passing `pt` renders Managed Login's default (English) page. Anything Managed Login
 * doesn't support (e.g. `pl`, `sq`, `me`, which referee-app ships for practice/training) falls
 * back to `en`.
 */

const MANAGED_LOGIN_LANG_MAP: Record<string, string> = {
  en: 'en',
  de: 'de',
  es: 'es',
  pt: 'pt-BR',
  fr: 'fr',
};

export function toManagedLoginLang(lang: string | undefined): string {
  const prefix = (lang ?? '').slice(0, 2).toLowerCase();
  return MANAGED_LOGIN_LANG_MAP[prefix] ?? 'en';
}
